<template>
  <div class="form-row">
    <div class="form-group">
      <input @change="selected_file" type="file" class="form-control" :id="prefix">
      <input type="hidden" :id="prefix + '_filename'" :name="prefix + '_filename'" :value="cur_filename" />
      <input type="hidden" :id="prefix + '_filesize'" :name="prefix + '_filesize'" :value="cur_filesize" />
      <input type="hidden" :id="prefix + '_original_name'" :name="prefix + '_original_name'" :value="cur_original_name" />
      <input type="hidden" :id="prefix + '_extension'" :name="prefix + '_extension'" :value="cur_extension" />
    </div>
    <div class="form-group ml-1">
      <button @click="upload(prefix)" type="button" class="btn btn-secondary ml-1">{{ __('Upload') }}</button>
      <span class="ml-1 font-weight-bold" v-show="!uploading && (complete || cur_filename)">
        {{ __('Upload complete.') }}
      </span>
      <span class="ml-1 font-weight-bold" v-show="uploading">
        {{ __('Uploading.') }} .... {{ percents }} %
      </span>
    </div>
  </div>
</template>

<script>
import AWS from 'aws-sdk'

export default {
  name: "UploadForm",
  props: {
    tag: String,
    mime: String,
    prefix: String,
    bucket: String,
    pool: String,
    region: String,
    filename: String,
    filesize: [String, Number],
    original_name: String,
    extension: String,
  },
  data() {
    return {
      upload_bucket: this.bucket,
      pool_id: this.pool,
      default_region: this.region,
      cur_filename: this.filename,
      cur_original_name: this.original_name,
      cur_filesize: this.filesize || 0,
      cur_extension: this.extension,
      upload_files: {},
      uploading: false,
      complete: false,
      percents: 0,
    };
  },
  methods: {
    selected_file(e) {
      e.stopPropagation();
      e.preventDefault();
      let files = e.target.files ? e.target.files : e.dataTransfer.files;
      this.upload_files[e.target.id] = files[0];
    },
    upload(target) {
      const s3 = new AWS.S3(),
            options = { partSize: 20 * 1024 * 1024, queueSize: 20 },
            uuid = Date.now(),
            upload_file = this.upload_files[target];

      if (!upload_file) {
        alert(this.__('The file is not set.'));
        return;
      }

      let ext = upload_file.name.match(/(?:\.([^.]+))?$/)[1] || "";
      let allowedExtensions = [];

      switch (this.mime) {
        case 'video': allowedExtensions = ["mp4", "mts", "mxf", "mov"]; break;
        case 'image': allowedExtensions = ['jpg', 'png', 'jpeg']; break;
        case 'attachments':
          allowedExtensions = ['pdf', 'doc', 'docs', 'jpeg', 'png', 'pptx', 'tga', 'ai', 'psd', 'xls', 'xlsx', 'xlsm', 'docx', 'zip'];
          break;
        case 'xml': allowedExtensions = ["xml"]; break;
      }

      if (!allowedExtensions.includes(ext.toLowerCase())) {
        alert('ファイル形式が違います。' + ext);
        return;
      }

      if (this.mime === 'video') {
        const maxSize = 1024 * 1024 * 1024 * 150; // 150GB
        if (upload_file.size > maxSize) {
          alert('動画サイズが150GBを超えています。');
          return;
        }
      }

      const filename = `${target}/${uuid}/${this.prefix}.${ext}`;
      this.cur_filesize = upload_file.size;
      this.cur_filename = filename;
      this.cur_original_name = upload_file.name;
      this.cur_extension = ext;

      const contents_uploads = ['document1', 'document2', 'thumbnail', 'image1', 'image2'];
      const upload_filename = contents_uploads.includes(this.prefix) ? 'uploads/' + filename : filename;

      const params = {
        Bucket: this.upload_bucket,
        Key: upload_filename,
        ContentType: upload_file.type,
        Body: upload_file,
        ACL: "private"
      };

      this.uploading = true;
      this.complete = false;

      // emit for Vue parent
      this.$emit('uploading', true);
      // emit for external JS (DOM)
      this.$el.dispatchEvent(new CustomEvent('uploading', { detail: true }));

      // グローバルにも書き込む
      window.__uploadStatus__ = {
        isUploading: true,
        isUploaded: false,
        filename: ''
      };

      s3.upload(params, options)
        .on('httpUploadProgress', evt => {
          this.percents = parseInt((evt.loaded * 100) / evt.total);
        })
        .send((err, data) => {
          if (err) {
            console.error(err);
            this.uploading = false;
            this.$emit('uploading', false);
            this.$el.dispatchEvent(new CustomEvent('uploading', { detail: false }));
            return;
          }

          this.uploading = false;
          this.complete = true;

          // this.notifyUploadComplete();

          this.$emit('uploading', false);
          this.$el.dispatchEvent(new CustomEvent('uploading', { detail: false }));
          this.$emit('complete', this.tag);

          window.__uploadStatus__ = {
            isUploading: false,
            isUploaded: true,
            filename: this.cur_filename
          };
        });
    },
    notifyUploadComplete() {
      if (!window.axios) {
        return;
      }

      window.axios.post('/api/upload/complete', {
        upload_filename: this.cur_filename,
        original_name: this.cur_original_name,
        filesize: this.cur_filesize,
      }).catch((error) => {
        console.error('upload complete notify failed', error);
      });
    }
  },
  mounted() {
    AWS.config.region = this.default_region;
    AWS.config.credentials = new AWS.CognitoIdentityCredentials({ IdentityPoolId: this.pool_id });
    AWS.config.credentials.get(err => console.log(err || 'Cognito Itentity Id: ' + AWS.config.credentials.identityId));
    //this.upload_id = this.$el.dataset.upload_id;
  }
}
</script>
